'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

$(()->
  $id = $('body').attr('id')
  $class = $('body').attr('class')

  # フッター高さ取得
  footerHeight =
    ()->
      add = 0
      height = $('#footer').height()
      outerHeight = $('#footer').outerHeight(true)
      diff = height - outerHeight
      if diff > 0
        $('#content').css('padding-bottom',height+add)
        $('#footer').css('height',height)
      else
        $('#content').css('padding-bottom',outerHeight+add)
        $('#footer').css('height',height)
      return

  footerHeight()

  $(window).on('load resize',
    ->
      footerHeight()
  )

smoothScroll = ($target)->
  $('html,body').animate({
    scrollTop:$($target.attr('href')).offset().top - 80
  },{
    easing:'easeInOutCirc',
    duration:1000
  })

  return false

$('a[href^="#"]'+'a[href!="#"]').on('click.smoothScroll'
  (e)->
    e.preventDefault()
    smoothScroll($(this))

    return
)

$('.js-tab-item a[href^="#"]').on('focus',
  (e)->
    $(this).off('click.smoothScroll')
)

$('.js-tab-item a[href^="#"]').on('click',
  (e)->
    $parent = $(this).closest('.js-tab-box')
    e.preventDefault()
    $parent.find('.js-tab-item').removeClass('is-active')
    $(this).parent().addClass('is-active')
    $parent.find('.js-tab-box-contents').removeClass('is-active')
    $($(this).attr('href')).addClass('is-active')
)

# アコーディオン
$('.js-accordion-title').on('click',
  ()->
    $parent = $root = $(this).closest('.js-accordion')
    $parent.removeClass('is-close')
    $parent.toggleClass('is-open')
    parentContentsHeight = rootContentsHeight = $parent.find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()

    if $parent.hasClass('is-open')
      $parent.find('> .js-accordion-contents').css({
        'height': parentContentsHeight
        'maxHeight': parentContentsHeight
      })
    else
      $parent.find('> .js-accordion-contents').removeAttr('style')

    if $parent.hasClass('is-open-all')
      $parent.toggleClass('is-open-all')
      $parent.addClass('is-close-all')
    else if $parent.hasClass('is-close-all')
      $parent.toggleClass('is-close-all')
      $parent.addClass('is-open-all')

    if $parent.hasClass('js-subaccordion')
      $root = $parent.parents('.js-accordion')
      rootContentsHeight = $root.find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()

      if $root.hasClass('is-open') and $parent.hasClass('is-open')
        $root.addClass('is-open-all')
      else
        $root.removeClass('is-open-all')

      if $root.hasClass('is-open')
        if $root.hasClass('is-open-all')
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight + parentContentsHeight else parentContentsHeight
        else
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight - parentContentsHeight else parentContentsHeight

        $root.find('> .js-accordion-contents').removeAttr('style')
        $root.find('> .js-accordion-contents').css({
          'height': allContentsHeight
          'maxHeight': allContentsHeight
        })

    $parent.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
      ()->
        if not $parent.hasClass('is-open')
          $parent.addClass('is-close')
    )
)

# new WOW().init()

# ヘッダー追従メニュー
firstUpFlg = false
firstDownFlg = true

$('.l-header__navi').headroom({
  offset: $('.l-header').height() - $('.l-header__navi').outerHeight()
  onPin: ()->
  onUnpin: ()->
  onTop: ()->
  onNotTop: ->
})

$gnavi =$('.l-header__navi')
$gnaviItem =$('.l-header__navi .item')
$navContents = $('.p-box')
navContentsPos = {}

$navContents.each(
  (index, val)->
    if $(this).attr('id')
      position = {}
      position[$(this).attr('id')] = $(this).offset().top
      navContentsPos[Object.keys(navContentsPos).length] = position
)

$(window).scroll(
  ()->
    if $(window).scrollTop() < $('.l-header__logo').height() + $('.l-header__mainvisual').outerHeight()
      $('.p-fix').removeClass('is-fixed')
    else
      $('.p-fix').addClass('is-fixed')

    $.each(navContentsPos,
      (key, val)->
        target = Object.keys(val)
        $target = $('#'+target)

        if $(window).scrollTop() >= $target.position().top - $gnavi.height() and
        $(window).scrollTop() < $target.position().top + $target.outerHeight(true)
          $gnavi.find('.'+target).addClass('is-active')
          $gnaviItem.not('.'+target).removeClass('is-active')

        if $(window).scrollTop() < $($navContents.get(0)).position().top - $gnavi.height()
          $gnaviItem.removeClass('is-active')

        if $(window).scrollTop() + $(window).height() >= $target.position().top and
        $(window).scrollTop() + $(window).height() < $target.position().top + $target.outerHeight(true)
          if $target.hasClass('js-has-cv')
            if not $('.l-fix-cv').hasClass('is-hide')
              $('.l-fix-cv').addClass('is-hide')
          else
            if $('.l-fix-cv').hasClass('is-hide')
              $('.l-fix-cv').removeClass('is-hide')
      )
)

$('l-header__navi .item').find('a').on('mouseover',
  (e)->
    $(this).off('click.smoothScroll')
)

$('l-header__navi .item').find('a').on('click',
  (e)->
    e.preventDefault()

    if not $(this).parent().hasClass('is-active')
      $(this).one('click.smoothScroll', smoothScroll($(this)))
)

)
